<template>
  <div v-loading.body="loading">
    <search-form
      v-model="form"
      @search="handleFormSearch"
      @export="handleFormExport"
      @export-detail="handleFormExportDetail"
      @compensation-setting="handleFormCompensationSetting"
      @id-clear="handleFormIdClear"
    />

    <compensation-list
      :data="resData"
      :loading="tableLoading"
      :page-size="form.pageSize"
      :current-page="form.page"
      @detail="handleDetail"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <el-dialog title="操作日志" :visible.sync="logVisible">
      <el-table :data="logData">
        <el-table-column
          property="admin"
          label="操作人"
          align="center"
        ></el-table-column>
        <el-table-column
          property="operate_mode"
          label="操作方式"
          align="center"
        ></el-table-column>

        <el-table-column
          property="operate_result"
          label="操作结果"
          align="center"
        ></el-table-column>
        <el-table-column
          property="created_at"
          label="操作时间"
          align="center"
        ></el-table-column>
        <el-table-column
          property="remark"
          label="备注"
          align="center"
        ></el-table-column>
      </el-table>
    </el-dialog>

    <!-- 履约返佣商家名单 -->
    <el-dialog
      width="520px"
      title="履约返佣商家名单"
      :visible.sync="supplyListVisible"
    >
      <el-button type="success" @click="handleExport"> 导出名单 </el-button>
      <div style="display: flex; align-items: center; margin-top: 16px">
        <el-upload
          ref="upload"
          :action="action"
          name="file"
          :limit="1"
          :on-success="handleSupplyListUploadSuccess"
          :on-error="handleSupplyListUploadError"
          :show-file-list="false"
          auto-upload
          with-credentials
        >
          <el-button type="warning"> 导入并更新名单 </el-button>
        </el-upload>
        <span style="margin-left: 8px">
          导入格式：A列=商家ID，B列=履约返佣类型（代号）
        </span>
      </div>
    </el-dialog>

    <!-- 赔付设置日志弹窗 -->
    <el-dialog
      title="赔付设置日志"
      :visible.sync="settingLogVisible"
      width="82%"
    >
      <el-table :data="settingLogs" border>
        <el-table-column
          prop="before"
          label="修改前"
          min-width="530"
          header-align="center"
          show-overflow-tooltip
        >
          <template #default="scope">
            <div v-if="scope.row.before">
              <p v-for="(item, index) in scope.row.before" :key="index">
                商品销售价区间：{{ item.minPrice || "0" }}-{{
                  item.maxPrice || "正无限"
                }}， 超时赔付计算：{{
                  item.overtimeType === "percentage" ? "比例" : "绝对值"
                }}{{ item.overtimeValue
                }}{{ item.overtimeType === "percentage" ? "%" : "元" }}，
                断货赔付计算：{{
                  item.shortageType === "percentage" ? "比例" : "绝对值"
                }}{{ item.shortageValue
                }}{{ item.shortageType === "percentage" ? "%" : "元" }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="after"
          label="修改后"
          min-width="530"
          header-align="center"
          show-overflow-tooltip
        >
          <template #default="scope">
            <div>
              <p v-for="(item, index) in scope.row.after" :key="index">
                商品销售价区间：{{ item.minPrice || "0" }}-{{
                  item.maxPrice || "正无限"
                }}， 超时赔付计算：{{
                  item.overtimeType === "percentage" ? "比例" : "绝对值"
                }}{{ item.overtimeValue
                }}{{ item.overtimeType === "percentage" ? "%" : "元" }}，
                断货赔付计算：{{
                  item.shortageType === "percentage" ? "比例" : "绝对值"
                }}{{ item.shortageValue
                }}{{ item.shortageType === "percentage" ? "%" : "元" }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="operator"
          label="操作人"
          width="80"
          align="center"
        />
        <el-table-column
          prop="operateTime"
          label="操作时间"
          width="180"
          align="center"
        />
      </el-table>
    </el-dialog>

    <!-- 赔付设置弹窗 -->
    <compensation-setting :visible.sync="settingDialogVisible" />
  </div>
</template>

<script>
import { logList } from "@/controller/refundBill.js";
import apiBaseURL from "@/utils/baseUrl.js";
import { postExportSupply } from "@/openapi/erp/refundBill.js";
import { openDownloadWindow } from "@/utils/export.js";
import SearchForm from "./components/SearchForm.vue";
import CompensationList from "./components/CompensationList.vue";
import CompensationSetting from "./components/CompensationSetting.vue";
import {
  postGetSlowCompensationList,
  postExportSlowCompensationList,
  postExportSlowCompensationDetail,
  postGetCompensationSettingsLog,
} from "@/openapi/erp/slowCompensation.js";

const IS_STATISTIC = 1;
export default {
  components: {
    SearchForm,
    CompensationList,
    CompensationSetting,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.srb_id) {
        const newForm = {
          ...vm.form,
          srb_id: to.query.srb_id,
          created_time: [],
        };
        vm.$set(vm, "form", newForm);
      }
    });
  },
  data() {
    return {
      IS_STATISTIC,
      logVisible: false,
      logData: [],
      resData: null,
      form: {
        scId: "",
        type: ["1", "2"],
        status: ["1", "2", "3"],
        userId: "",
        orderId: "",
        supplyName: "",
        supplyId: "",
        productNo: "",
        styleNo: "",
        sku: "",
        orderTime: null,
        createdTime: null,
        completeTime: null,
        pageSize: 10,
        page: 1,
      },
      loading: false,
      tableLoading: false,
      url: "/erp/RefundBill/index",
      filterFold: false,
      multipleSelection: [],
      searchOps: {
        types: [
          {
            key: 1,
            label: "佣金奖励",
          },
          {
            key: 2,
            label: "退货服务费奖励",
          },
          {
            key: 3,
            label: "提前上新返佣奖励",
          },
          {
            key: 4,
            label: "履约达标返佣奖励",
          },
          {
            key: 5,
            label: "履约达标返佣奖励(新)",
          },
          {
            key: 6,
            label: "履约达标返佣奖励(2024)",
          },
        ],
        status: [
          {
            key: 0,
            label: "待分账",
          },
          {
            key: 1,
            label: "分账中",
          },
          {
            key: 2,
            label: "分账成功",
          },
          {
            key: 3,
            label: "分账失败",
          },
          {
            key: 4,
            label: "挂起",
          },
          {
            key: 5,
            label: "异常",
          },
        ],
      },
      supplyListVisible: false,
      action: `${apiBaseURL}/erp/RefundBill/importSupply`,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      settingDialogVisible: false,
      settingLogVisible: false,
      settingLogs: [],
    };
  },
  computed: {
    filteredForm() {
      const result = {};
      const formData = this.form;

      Object.keys(formData).forEach((key) => {
        const value = formData[key];
        if (value !== undefined && value !== "" && value !== null) {
          const apiKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
          result[apiKey] = value;
        }
      });

      return result;
    },
  },
  methods: {
    async fetchData(showLoading = false) {
      if (showLoading) {
        this.loading = true;
      }
      try {
        const res = await postGetSlowCompensationList(this.filteredForm);

        if (res) this.resData = res;
      } catch (error) {
        this.$message.error("获取数据失败");
      } finally {
        this.loading = false;
      }
    },

    handleFormSearch(formData) {
      this.form = { ...this.form, ...formData };
      this.fetchData(true);
    },

    handleFormExport() {
      postExportSlowCompensationList({
        ...this.filteredForm,
        is_excel: 1,
      })
        .then((res) => {
          if (res.file) {
            window.open(apiBaseURL + res.file);
          } else {
            this.$message.error("导出失败");
          }
        })
        .catch(() => this.$message.error("导出失败"));
    },

    handleFormExportDetail() {
      postExportSlowCompensationDetail({
        ...this.filteredForm,
        is_excel: 1,
      })
        .then((res) => {
          if (res.file) {
            window.open(apiBaseURL + res.file);
          } else {
            this.$message.error("导出明细失败");
          }
        })
        .catch(() => this.$message.error("导出明细失败"));
    },

    handleFormCompensationSetting() {
      this.settingDialogVisible = true;
    },

    async fetchCompensationSettingsLog() {
      try {
        const res = await postGetCompensationSettingsLog();
        if (res.code === 200) {
          this.settingLogs = res.data.map((log) => ({
            before: log.before ? JSON.parse(log.before) : null,
            after: JSON.parse(log.after),
            operator: log.operator,
            operateTime: log.operate_time,
          }));
          this.settingLogVisible = true;
        } else {
          this.$message.error(res.msg || "获取赔付设置日志失败");
        }
      } catch (error) {
        this.$message.error("获取赔付设置日志失败");
      }
    },

    handleDetail(row) {
      console.log("跳转详情，行数据:", row);

      // 确保使用正确的ID字段
      const { id } = row;

      if (!id) {
        this.$message.error("赔付单ID不存在");
        return;
      }

      this.$router.push({
        path: "merchant-claims-detail",
        query: { id },
      });
    },

    handleSizeChange(val) {
      this.form.pageSize = val;
      this.form.page = 1;
      this.fetchData();
    },

    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData();
    },

    handleIdClear() {
      // 重置页码和相关状态
      this.form.page = 1;
      this.fetchData(true);
    },

    handleSendMsg() {
      // 实现发送短信的逻辑
    },
    handleLogOpen(row) {
      logList({ srb_id: row.srb_id })
        .then((data) => {
          this.logData = data;
          this.logVisible = true;
        })
        .catch(this.$noop);
    },
    // 导出返佣商家名单
    handleExport() {
      postExportSupply({}).then(openDownloadWindow).catch(this.$noop);
    },
    // 导入返佣商家名单成功
    handleSupplyListUploadSuccess(res) {
      if (res.code !== 200) {
        this.$message.error(res.msg);
      } else if (res.data.file) {
        this.$message.error("导入数据有误，已自动下载");
        openDownloadWindow(res.data);
      } else {
        this.$message.success("导入成功");
      }
      this.$refs.upload.clearFiles();
    },
    // 导入返佣商家名单失败
    handleSupplyListUploadError() {
      this.$refs.upload.clearFiles();
    },

    hasPermission(/* permission */) {
      // 权限检查逻辑
      return true; // 临时返回
    },

    handleFormIdClear() {
      this.handleIdClear();
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.setting-row {
  margin-bottom: 20px;
  padding: 10px;
  border-bottom: 1px solid #ebeef5;
}

.price-input {
  width: 120px;
}

.separator {
  margin: 0 10px;
}

.calc-type {
  width: 120px;
  margin-right: 10px;
}

.calc-value {
  width: 120px;
}

.setting-footer {
  margin-top: 20px;
  text-align: left;
}

.el-table ::v-deep .cell {
  white-space: pre-line;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/pages/merchantClaimsOrder/index.vue